/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-single-option-selector], label')) return;
    setTimeout(updateVariantFix, 150);
  });

  document.addEventListener('change', function(e) {
    if (!e.target.matches('[data-single-option-selector]')) return;
    updateOptionLabel(e.target);
    setTimeout(updateVariantFix, 150);
  });

  function updateOptionLabel(input) {
    if (input.type === 'radio' && !input.checked) return;
    var index = input.getAttribute('data-index');
    if (!index) return;
    var position = index.replace('option', '');
    var wrapper = input.closest('[data-option-position="' + position + '"]');
    if (!wrapper) return;
    var label = wrapper.querySelector('[data-option-value]');
    if (label) label.textContent = input.value;
  }

  function updateVariantFix() {
    var productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    var product = JSON.parse(productJsonEl.textContent);
    var selected = [];

    document.querySelectorAll('[data-single-option-selector]').forEach(function(input) {
      if (input.closest('noscript')) return;

      var index = input.getAttribute('data-index');
      if (!index) return;

      if (input.type === 'radio' && !input.checked) return;

      var position = parseInt(index.replace('option', ''), 10) - 1;
      selected[position] = input.value;
    });

    var variant = product.variants.find(function(v) {
      return v.options.every(function(option, i) {
        return option === selected[i];
      });
    });

    if (!variant) return;

    document.querySelectorAll('input[name="id"]').forEach(function(input) {
  input.value = variant.id;
  input.setAttribute('value', variant.id);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

    if (variant.featured_media && variant.featured_media.id) {
      var media = document.querySelector('[data-media-id$="' + variant.featured_media.id + '"]');

      if (media) {
        media.dispatchEvent(new CustomEvent('theme:media:select', {
          bubbles: true,
          detail: {
            id: media.getAttribute('data-media-id')
          }
        }));
      }
    }

    history.replaceState({}, '', window.location.pathname + '?variant=' + variant.id);
  }
})();
